import i18n from "@/lang";

const app_title = i18n.t("app_title");

export function generateTitle(title) {
  const hasKey = this.$te("routes." + title);

  if (hasKey) {
    // $t :this method from vue-i18n, inject in @/lang/index.js
    const translatedTitle = this.$t("routes." + title);

    return translatedTitle;
  }
  return title;
}

export function tableTitle(title) {
  const hasKey = i18n.te("table." + title);
  if (hasKey) {
    const translatedTitle = i18n.t("table." + title);
    return translatedTitle;
  }
  return title;
}

export default function getPageTitle(pageTitle) {
  const hasKey = i18n.te("routes." + pageTitle);

  if (hasKey) {
    const translatedTitle = i18n.t("routes." + pageTitle);
    return `${translatedTitle} | ${app_title}`;
  }
  return " ";
}
